import CircleFillOutWithText from '@/components/molecules/WellnessStateCircle/CircleFillOutWithText';
import { DOMAIN_INTERPRETATION_LEVEL_LABELS, WELLNESS_STATE_LIMIT_DANGER, WELLNESS_STATE_LIMIT_OK } from '@/constants';
import { HStack, Text, VStack } from '@chakra-ui/react';
import React from 'react';

const YourScore = ({
  score,
  horizontal = false,
  svgId,
  isOrganization,
}: {
  score: number;
  horizontal?: boolean;
  svgId: string;
  isOrganization?: boolean;
}) => {
  return (
    <HStack width={'100%'} justify={'space-between'} alignItems={'center'}>
      {horizontal ? (
        <HStack alignItems={'center'} justifyContent={'center'}>
          <Text variant={'loraExtraSmallTitle'} color={'text.mediumGray'}>
            {isOrganization ? `Organization's` : `Your`} Score:
          </Text>
          <HStack marginTop={'2px'} marginLeft={'6px'}>
            <Text variant={'urbanistBlackLarge'} color={'text.mediumBlue'}>
              {score.toFixed()} / 100
            </Text>
            <Text variant={'urbanistMediumLarge'} fontSize={18} color={'text.mediumBlue'}>
              {score <= WELLNESS_STATE_LIMIT_DANGER
                ? DOMAIN_INTERPRETATION_LEVEL_LABELS.IMMEDIATE_CONCERN
                : score >= WELLNESS_STATE_LIMIT_OK
                  ? DOMAIN_INTERPRETATION_LEVEL_LABELS.STRENGTH
                  : DOMAIN_INTERPRETATION_LEVEL_LABELS.MODERATE_CONCERN}
            </Text>
          </HStack>
        </HStack>
      ) : (
        <VStack alignItems={'start'}>
          <Text variant={'loraRegular18'} color={'text.mediumGray'} marginTop={'4px'}>
            {isOrganization ? `Organization's` : `Your`} Score:
          </Text>
          <HStack>
            <Text variant={'urbanistBlackLarge'} color={'text.mediumBlue'}>
              {score.toFixed()} / 100
            </Text>
            <Text variant={'urbanistMediumLarge'} fontSize={18} color={'text.mediumBlue'}>
              {score <= WELLNESS_STATE_LIMIT_DANGER
                ? DOMAIN_INTERPRETATION_LEVEL_LABELS.IMMEDIATE_CONCERN
                : score >= WELLNESS_STATE_LIMIT_OK
                  ? DOMAIN_INTERPRETATION_LEVEL_LABELS.STRENGTH
                  : DOMAIN_INTERPRETATION_LEVEL_LABELS.MODERATE_CONCERN}
            </Text>
          </HStack>
        </VStack>
      )}
      <CircleFillOutWithText
        percentageFilled={score}
        boxShadow="none"
        svgId={`${svgId}-your-score-id`}
        circleDiameter={46}
        thickness={8}
        hasBackgroundCircleFillOut
        showPercentageText={false}
      />
    </HStack>
  );
};

export default YourScore;
